<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Mapa de Cotações">
        <b-card-body>
  
          <b-row>
  
            <b-col cols="auto" class="mr-auto">
                <b-form-group>
                    <!--
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    -->
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
  
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--<b-button variant="vine" class="mr-1 btn-brand" @click="approveSelected()"  v-show="tableSelectable"><i class="fa fa-thumbs-o-up"></i><span>Aprovar Selecionados</span></b-button> -->
              
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
                foot-clone
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <template #thead-top='data'>
                    <b-tr>
                        <b-th colspan="4" ><span class="sr-only"></span></b-th>
                        <b-th colspan="5" :variant="item.variant" v-for="item in suppliers" :key="item.id">
                               <tr class="small">
                                <td>Fornecedor</td>
                                <td>{{ item.name }}</td>
                                </tr>
                                <tr class="small">
                                <td>Pagamento</td>
                                <td>{{ item.mop }}</td>
                                </tr>
                                <tr class="small">
                                <td>Contato</td>
                                <td>{{ item.contact }}</td>
                                </tr>
                        </b-th>                        
                    </b-tr>
                </template>

                <template #foot(qty)="data">
                  <p class="text-dark font-weight-bold">Total</p>
                  <p class="text-danger font-weight-bold">Selecionado</p>
                </template>
                <template #foot(suppliers_total_0)="data">
                  <p class="text-dark font-weight-bold">12354.45</p>
                  <p class="text-danger font-weight-bold">56465.54</p>
                </template>
                <template #foot(suppliers_total_1)="data">
                  <p class="text-dark font-weight-bold">12354.45</p>
                  <p class="text-danger font-weight-bold">56465.54</p>
                </template>
                <template #foot(suppliers_total_2)="data">
                  <p class="text-dark font-weight-bold">12354.45</p>
                  <p class="text-danger font-weight-bold">56465.54</p>
                </template>
                <template #foot(suppliers_total_3)="data">
                  <p class="text-dark font-weight-bold">12354.45</p>
                  <p class="text-danger font-weight-bold">56465.54</p>
                </template>
                <template #foot()="data">
                  <p></p>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(product)="data">
                    {{  data.item.product }}
                </template>

                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

                <template v-slot:cell(suppliers_unit_0)="data">
                  {{ suppliers.hasOwnProperty(0) ? formatAsNumber(getFieldById(data.item, suppliers[0].id, 'unitvalue'),'') : ''}}
                </template>
                <template #cell(suppliers_unit_1)="data">
                  {{ suppliers.hasOwnProperty(1) ? formatAsNumber(getFieldById(data.item, suppliers[1].id, 'unitvalue'),'') : '' }}
                </template>
                <template #cell(suppliers_unit_2)="data">
                  {{ suppliers.hasOwnProperty(2) ? formatAsNumber(getFieldById(data.item, suppliers[2].id, 'unitvalue'),'') : '' }}
                </template>
                <template #cell(suppliers_unit_3)="data">
                  {{ suppliers.hasOwnProperty(3) ? formatAsNumber(getFieldById(data.item, suppliers[3].id, 'unitvalue'),'') : '' }}
                </template>


                
                <template v-slot:cell(suppliers_total_0)="data">
                  {{ suppliers.hasOwnProperty(0) ? formatAsNumber(data.item.qty * getFieldById(data.item, suppliers[0].id, 'unitvalue',''),'') : '' }}
                </template>
                <template #cell(suppliers_total_1)="data">
                  {{ suppliers.hasOwnProperty(1) ? formatAsNumber(data.item.qty * getFieldById(data.item, suppliers[1].id, 'unitvalue',''),'') : '' }}
                </template>
                <template #cell(suppliers_total_2)="data">
                  {{ suppliers.hasOwnProperty(2) ? formatAsNumber(data.item.qty * getFieldById(data.item, suppliers[2].id, 'unitvalue',''),'') : ''  }}
                </template>
                <template #cell(suppliers_total_3)="data">
                  {{ suppliers.hasOwnProperty(3) ? formatAsNumber(data.item.qty * getFieldById(data.item, suppliers[3].id, 'unitvalue',''),'') : ''  }}
                </template>
                

                <template v-slot:cell(suppliers_deliverydate_0)="data">
                  {{ suppliers.hasOwnProperty(0) ? getFieldById(data.item, suppliers[0].id, 'deliverydate') : ''  }}
                </template>
                <template #cell(suppliers_deliverydate_1)="data">
                  {{ suppliers.hasOwnProperty(1) ? getFieldById(data.item, suppliers[1].id, 'deliverydate') : ''  }}
                </template>
                <template #cell(suppliers_deliverydate_2)="data">
                  {{ suppliers.hasOwnProperty(2) ? getFieldById(data.item, suppliers[2].id, 'deliverydate') : ''  }}
                </template>
                <template #cell(suppliers_deliverydate_3)="data">
                  {{ suppliers.hasOwnProperty(3) ? getFieldById(data.item, suppliers[3].id, 'deliverydate')  : '' }}
                </template>


                <template v-slot:cell(suppliers_notes_0)="data">
                  {{ suppliers.hasOwnProperty(0) ? getFieldById(data.item, suppliers[0].id, 'notes') : ''  }}
                </template>
                <template v-slot:cell(suppliers_notes_1)="data">
                  {{ suppliers.hasOwnProperty(1) ? getFieldById(data.item, suppliers[1].id, 'notes') : ''  }}
                </template>
                <template v-slot:cell(suppliers_notes_2)="data">
                  {{ suppliers.hasOwnProperty(2) ? getFieldById(data.item, suppliers[2].id, 'notes') : ''  }}
                </template>
                <template v-slot:cell(suppliers_notes_3)="data">
                  {{ suppliers.hasOwnProperty(2) ? getFieldById(data.item, suppliers[3].id, 'notes') : ''  }}
                </template>


                <template v-slot:cell(suppliers_checked_0)="data">
                  <b-form-checkbox></b-form-checkbox>
                </template>
                <template v-slot:cell(suppliers_checked_1)="data">
                  <b-form-checkbox ></b-form-checkbox>
                </template>
                <template v-slot:cell(suppliers_checked_2)="data">
                  <b-form-checkbox ></b-form-checkbox>
                </template>
                <template v-slot:cell(suppliers_checked_3)="data">
                  <b-form-checkbox ></b-form-checkbox>
                </template>
            

            </b-table>
            <nav v-show="totalRows > perPage">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Documento"
              size="xl">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Id"
                label-for="id"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Título"
                label-for="title"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.title" id="title" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Resumo"
                label-for="summary"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.summary"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Conteúdo"
                label-for="content"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.content"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <b-button variant="html5" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-times"></i><span>Cancelar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Documento</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
  
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          key: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        
        items: [
            {
              id: 23213,
              st: 'A', 
              productcode: '74', 
              product: "ADESIVAGEM", 
              description: "1 caixa de etiqueta redonda adesiva Pimaco", 
              istech: 1, 
              qty: 1, 
              approvedqty: 0, 
              createdin: "2022-11-10 16:37:00",
              suppliers: [
                  {
                      id: 15324,
                      deliverydate: '',
                      qty: 1,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',       
                      unitvalue: 128.45,
                      checked: false
                  },
                  {
                      id: 100,
                      deliverydate: '15/03',
                      qty: 1,
                      approvedqty: 0,
                      approvedby: null,
                      notes: 'Material de desmobilização',
                      unitvalue: 158.35,
                      checked: false
                  }
              ],
              class: "outline-primary", _rowVariant: 'none'
            }, 
            {
              id: 23214,
              st: 'A', 
              productcode: '2832', 
              product: "BLOQUEADOR DE ODOR FREECÔ 500ML - REFIL", 
              description: "1 caixa de etiqueta redonda adesiva Pimaco", 
              istech: 1, 
              qty: 12, 
              approvedqty: 0, 
              createdin: "2022-11-10 16:37:00",
              suppliers: [
                  {
                      id: 15324,
                      deliverydate: '',
                      qty: 12,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',
                      unitvalue: 18.23,
                      checked: false
                  },
                  {
                      id: 100,
                      deliverydate: '',
                      qty: 12,
                      approvedqty: 0,
                      approvedby: null,
                      notes: 'Material de desmobilização',
                      unitvalue: 22.45,
                      checked: false
                  }
              ],
              class: "outline-primary", _rowVariant: 'none'
            }, 
            {
              id: 23215,
              st: 'A', 
              productcode: '2752', 
              product: "BOTA PROTEÇÃO / NR10", 
              description: "1 caixa de etiqueta redonda adesiva Pimaco", 
              istech: 1, 
              qty: 8, 
              approvedqty: 0, 
              createdin: "2022-11-10 16:37:00",
              suppliers: [
                  {
                      id: 15324,
                      deliverydate: '20/02',
                      qty: 8,
                      approvedqty: 0,
                      approvedby: null,
                      notes: 'Observação de teste',
                      selected: false,
                      unitvalue: 49.80,
                      checked: false
                  },
                  {
                      id: 300,
                      deliverydate: '',
                      qty: 8,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',
                      selected: false,
                      unitvalue: 53.20,
                      checked: false
                  }
              ],
              class: "outline-primary", _rowVariant: 'none'
            }, 
            {
              id: 23216,
              st: 'A', 
              productcode: '2831', 
              product: "LIVRO DESCUBRA SEUS PONTOS FORTES 2.0 - DON CLIFTON E TOM RATH", 
              description: "1 caixa de etiqueta redonda adesiva Pimaco", 
              istech: 1, 
              qty: 6, 
              approvedqty: 0, 
              createdin: "2022-11-10 16:37:00",
              suppliers: [
                  {
                      id: 15324,
                      deliverydate: '',
                      qty: 6,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',
                      selected: false,
                      unitvalue: 22.68,
                      checked: false
                  },
                  {
                      id: 200,
                      deliverydate: '',
                      qty: 6,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',
                      selected: false,
                      unitvalue: 25.12,
                      checked: false
                  }
              ],
              class: "outline-primary", _rowVariant: 'none'
            }, 
            {
              id: 23217,
              st: 'A', 
              productcode: '1912', 
              product: "PANO DE CHÃO - SACO ALVEJADO", 
              description: "1 caixa de etiqueta redonda adesiva Pimaco", 
              istech: 1, 
              qty: 3, 
              approvedqty: 0, 
              createdin: "2022-11-10 16:37:00",
              suppliers: [
                  {
                      id: 15324,
                      deliverydate: '',
                      qty: 3,
                      approvedqty: 0,
                      approvedby: null,
                      notes: '',
                      selected: false,
                      unitvalue: 13.89,
                      checked: false
                  },
                  {
                      id: 100,
                      deliverydate: '',
                      qty: 3,
                      approvedqty: 0,
                      approvedby: null,
                      notes: 'Material de desmobilização',
                      selected: false,
                      unitvalue: 17.22,
                      checked: false
                  }
              ],
              class: "outline-primary", _rowVariant: 'none'
            },            
          ],
          fields: [
            {key: 'show_details', label: "", thStyle: { width: "50px" } },
            {key: 'productcode', label: 'Código', sortable: true, thStyle: { width: '50px' } },
            {key: 'product', label: 'Item / Produto', sortable: true, thClass: 'tablecolumn' },
            {key: 'qty', label: 'Quantidade', sortable: false, thStyle: { width: '50px' }, tdClass: 'text-center'},

            {key: 'suppliers_checked_0', label: '', sortable: false, thStyle: { width: '15px' }, variant: 'warning' },
            {key: 'suppliers_unit_0', label: 'Unitário', sortable: false, thStyle: { width: '50px' }, variant: 'warning', tdClass: 'text-right' },
            {key: 'suppliers_total_0', label: 'Total', sortable: false, thStyle: { width: '50px' }, variant: 'warning', tdClass: 'text-right' },
            {key: 'suppliers_deliverydate_0', label: 'Entrega', sortable: false, thStyle: { width: '50px' }, variant: 'warning', tdClass: 'text-center' },
            {key: 'suppliers_notes_0', label: 'Obs/Espec', sortable: false, thStyle: { width: '50px' }, variant: 'warning' },
            
            {key: 'suppliers_checked_1', label: '', sortable: false, thStyle: { width: '15px' }, variant: 'primary' },
            {key: 'suppliers_unit_1', label: 'Unitário', sortable: false, thStyle: { width: '50px' }, variant: 'primary', tdClass: 'text-right' },
            {key: 'suppliers_total_1', label: 'Total', sortable: false, thStyle: { width: '50px' }, variant: 'primary', tdClass: 'text-right'},
            {key: 'suppliers_deliverydate_1', label: 'Entrega', sortable: false, thStyle: { width: '50px' }, variant: 'primary', tdClass: 'text-center' },
            {key: 'suppliers_notes_1', label: 'Obs/Espec', sortable: false, thStyle: { width: '50px' }, variant: 'primary' },
            
            {key: 'suppliers_checked_2', label: '', sortable: false, thStyle: { width: '15px' }, variant: 'success' },
            {key: 'suppliers_unit_2', label: 'Unitário', sortable: false, thStyle: { width: '50px' }, variant: 'success', tdClass: 'text-right' },
            {key: 'suppliers_total_2', label: 'Total', sortable: false, thStyle: { width: '50px' }, variant: 'success', tdClass: 'text-right' },
            {key: 'suppliers_deliverydate_2', label: 'Entrega', sortable: false, thStyle: { width: '50px' }, variant: 'success', tdClass: 'text-center' },
            {key: 'suppliers_notes_2', label: 'Obs/Espec', sortable: false, thStyle: { width: '50px' }, variant: 'success' },

            {key: 'suppliers_checked_3', label: '', sortable: false, thStyle: { width: '15px' }, variant: 'danger' },
            {key: 'suppliers_unit_3', label: 'Unitário', sortable: false, thStyle: { width: '50px' }, variant: 'danger', tdClass: 'text-right' },
            {key: 'suppliers_total_3', label: 'Total', sortable: false, thStyle: { width: '50px' }, variant: 'danger', tdClass: 'text-right' },
            {key: 'suppliers_deliverydate_3', label: 'Entrega', sortable: false, thStyle: { width: '50px' }, variant: 'danger', tdClass: 'text-center' },
            {key: 'suppliers_notes_3', label: 'Obs/Espec', sortable: false, thStyle: { width: '50px' }, variant: 'danger' },


            //{key: 'total', label: 'Total', sortable: true, thStyle: { width: "40px" } },
            //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
          ],

          suppliers: [
            {
              id: 15324,
              name: 'ESPACIAL SUPRIMENTOS DE ESCRITÓRIO LTDA',
              contact: 'TEREZINHA',
              phone: '1126026244',
              email: 'terezinha@espacial.com.br',
              mop: '30 DDL',
              variant: 'warning'
            },
            {
              id: 100,
              name: 'PLANETA EDUCAÇÃO GRÁFICA E EDITORA LTDA',
              contact: 'EDUARDO HARUNA',
              phone: '(12) 3878-4567',
              email: 'compras@vitaebrasil.com.br',
              mop: 'Imediato',
              variant: 'primary'
            },
            {
              id: 200,
              name: 'IMPAKTO SISTEMAS DE LIMPEZA E DESCARTAVEIS LTDA',
              contact: 'GABRIELA',
              phone: '11 123123213',
              email: 'gabriela@vendas.impakto.com.br',
              mop: '30DDL',
              variant: 'success'
            },
            {
              id: 300,
              name: 'IMPAKTO SISTEMAS DE LIMPEZA E DESCARTAVEIS LTDA',
              contact: 'GABRIELA',
              phone: '11 123123213',
              email: 'gabriela@vendas.impakto.com.br',
              mop: '30DDL',
              variant: 'danger'
            }
          ],

        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' || item.product.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1 || item.productcode.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
            })
        }
        catch(e) {
          console.log(e)
          return this.items;
        }
      }
    },
    methods: {
      formatAsNumber(val, defaultValue) {
        if(typeof val === 'number' && val > 0) {
          return parseFloat(val).toFixed(2);
        }
        return defaultValue;
      },

      getFieldById(item, id, fieldname, defaultvalue='') {
        var val = item.suppliers.find(x => x.id === id);
        if(val) {
          return val[fieldname];
        }
        return defaultvalue;        
      },

      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      save() {
        console.log('Salvando documento')
        console.log(this.selectedItem);
  
        toast ({
            type: VueNotifications.types.warn,
            title: 'Documento',
            message: 'Salvando',
            timeout: 3000
          })
      },
      approveSelected() {
        console.log('Habilitando/desabilitando documento')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = newItem;      
        }
        else {
            this.selectedItem = JSON.parse(JSON.stringify(item));
        }
        this.$router.push({ path: '/purchaseorder/financialapproval/item', query: item })
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
            this.clearSelectedRows();
            this.openEditModal(item);
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      }
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }

  .tablecolumn {
    min-width: 300px;
  }

  </style>
  